<microsec-loading-overlay [isLoading]="isLoading">
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <microsec-common-toolbar #ct [configuration]="filterConfiguration" [filterObject]="filterObject" [rightTemplate]="toolbarRightTemplate" />
      <ng-template #toolbarRightTemplate>
        <p-button icon="fa fa-refresh" severity="primary" (onClick)="getInstances()" />
      </ng-template>
    </div>
    @if (allInstances.length <= 0) {
      <!-- When Workflow Instance is empty -->
      <div class="col-span-12 text-center mt-20">
        <i class="fa-solid fa-diagram-next" style="font-size: 10em; color: #333333; text-align: center"></i>
      </div>
      <div class="col-span-12 mb-20">
        <p class="font-bold text-center">No Workflows</p>
      </div>
    } @else {
      <!-- All Worklow Instances -->
      <ng-template [ngTemplateOutlet]="workflowViewTemplate" [ngTemplateOutletContext]="{ instances: allInstances, status: null }"></ng-template>
    }
  </div>
</microsec-loading-overlay>

<!-- Workflow Instance View Template -->
<ng-template #workflowViewTemplate let-instances="instances" let-status="status">
  @if (instances.length > 0) {
    <div class="col-span-12">
      <p-dataView
        #dv
        styleClass="microsec-dashboard-dataView"
        [value]="instances"
        [loading]="isLoading"
        [paginator]="true"
        [rows]="PER_PAGE"
        [rowsPerPageOptions]="PER_PAGE_OPTIONS">
        <ng-template #list let-instances>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              @for (i of instances; track $index; let first = $first) {
                <div class="mb-4 border-0 w-full">
                  <microsec-card [isNestedCard]="true" [isBordered]="true">
                    <div class="flex flex-row p-1 w-full">
                      <div [style]="{ 'margin-top': '7px' }"><i class="fa-2x fa-solid fa-diagram-next"></i></div>
                      <div class="flex flex-col pl-4 w-full">
                        <div class="flex flex-row items-center">
                          <label class="font-bold"> {{ i.workflowName || 'Workflow' }} </label>
                          <div
                            class="custom-chip square ml-auto"
                            [ngClass]="{
                              'green': i.displayStatus === DISPLAY_INSTANCE_STATUSES.SUCCESS,
                              'orange': i.displayStatus === DISPLAY_INSTANCE_STATUSES.PARTIAL_SUCCESS,
                              'red': i.displayStatus === DISPLAY_INSTANCE_STATUSES.FAILURE,
                              'blue': i.displayStatus === DISPLAY_INSTANCE_STATUSES.RUNNING,
                              'grey': i.displayStatus === DISPLAY_INSTANCE_STATUSES.PENDING_APPROVAL,
                              'dark-grey': i.displayStatus === DISPLAY_INSTANCE_STATUSES.DENIED
                            }">
                            {{ i.displayStatus || '-' | titlecase }}
                          </div>
                        </div>
                        <label class="text-grey mt-1 mb-4"> {{ i.workflowDescription || '' }} </label>
                        <div class="flex flex-row mitigation-workflow-button">
                          @if (
                            i.displayStatus === DISPLAY_INSTANCE_STATUSES.SUCCESS ||
                            i.displayStatus === DISPLAY_INSTANCE_STATUSES.PARTIAL_SUCCESS ||
                            i.displayStatus === DISPLAY_INSTANCE_STATUSES.FAILURE ||
                            i.displayStatus === DISPLAY_INSTANCE_STATUSES.DENIED
                          ) {
                            <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
                              <p-button
                                class="mr-2"
                                styleClass="rerun-button"
                                label="Rerun"
                                severity="primary"
                                [disabled]="!isValidLicense() || !permissions[USER_ROLE.TECHNICIAN]"
                                (onClick)="rerunInstance($event, i)" />
                            </span>
                            <p-button
                              styleClass="goto-button"
                              label="Go To Workflow"
                              severity="primary"
                              (onClick)="navigateToWorkflow(i.workflow_id || null)" />
                          }
                          @if (i.displayStatus === DISPLAY_INSTANCE_STATUSES.RUNNING) {
                            <p-button
                              class="mr-2"
                              styleClass="running-button"
                              pTooltip="Running... Refresh to update"
                              [disabled]="true"
                              label="Running" />
                            <p-button styleClass="goto-button" label="Go To Workflow" (onClick)="navigateToWorkflow(i.workflow_id || null)" />
                          }
                          @if (i.displayStatus === DISPLAY_INSTANCE_STATUSES.PENDING_APPROVAL) {
                            <!-- approval split button to approve or deny -->
                            <span [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
                              <p-splitButton
                                #sb
                                styleClass="p-splitbutton-success approve-button"
                                appendTo="body"
                                menuStyleClass="microsec-button-context-menu"
                                [label]="WORKFLOW_INSTANCE_STATUSES.APPROVAL_REQUIRED.LABEL"
                                (onClick)="handleInstanceApproval(WORKFLOW_APPROVAL_ACTION_VALUES.APPROVE, i)"
                                (onDropdownClick)="onSBDClicked($event, i)"
                                [model]="approveButtonItems"
                                [disabled]="!isValidLicense() || !permissions[USER_ROLE.TECHNICIAN]"
                                [buttonDisabled]="!isValidLicense() || !permissions[USER_ROLE.TECHNICIAN]"
                                [menuButtonDisabled]="!isValidLicense() || !permissions[USER_ROLE.TECHNICIAN]" />
                            </span>
                            <p-button
                              class="ml-2"
                              styleClass="goto-button"
                              label="Go To Workflow"
                              severity="primary"
                              (onClick)="navigateToWorkflow(i.workflow_id || null)" />
                          }
                        </div>
                      </div>
                    </div>
                  </microsec-card>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  }
</ng-template>
